// extracted by mini-css-extract-plugin
export default {"sortBtn":"SortOrderToggle_sortBtn__7Uy28"};